import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CustomLoader from './CustomLoader';
export default function QuantityPicker(props) {
    const { plant, changeQuantity } = props;
    const [quantity, setQuantity] = React.useState(plant.quantity);
    const [changeLoading, setChangeLoading] = React.useState(false);
    React.useEffect(() => {
        setQuantity(plant.quantity);
    }, [plant.quantity]);
    const updateQuantity = async (e) => {
        plant.quantity = parseInt(e.target.value, 10) || quantity;
        if (quantity >= 0) {
            setChangeLoading(true);
            await changeQuantity(plant);
            if (plant.quantity !== 0)
                setChangeLoading(false);
        }
    };
    const changeQuantityValue = async (e) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (newQuantity !== quantity)
            setQuantity(newQuantity);
    };
    const keyPress = (e) => {
        if (e.key === 'Enter') {
            const newQuantity = parseInt(e.currentTarget.value, 10);
            setQuantity(newQuantity);
            updateQuantity(e);
        }
    };
    const changeQuantityOnClick = async (operation) => {
        let newQuantity = 0;
        if (operation === 'add') {
            newQuantity = quantity + 1;
        }
        else if (operation === 'minus') {
            if (quantity === 1)
                newQuantity = 0;
            else if (quantity < 2)
                newQuantity = 1;
            else
                newQuantity = quantity - 1;
        }
        setQuantity(newQuantity);
        plant.quantity = newQuantity;
        setChangeLoading(true);
        await changeQuantity(plant);
        if (newQuantity > 0)
            setChangeLoading(false);
    };
    const inputButtonRootSX = {
        padding: 0.25,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& svg': {
            fill: 'primary.dark',
        },
    };
    return (React.createElement(Box, { sx: {
            width: 95,
            display: 'inline-flex',
            border: 1,
            borderColor: 'secondary.dark',
            borderRadius: 1,
        } },
        React.createElement(IconButton, { sx: inputButtonRootSX, "aria-label": "minus", size: "small", onClick: () => changeQuantityOnClick('minus'), disabled: changeLoading || plant.shopify_quantity === 0 },
            React.createElement(RemoveIcon, null)),
        changeLoading ? (React.createElement(CustomLoader, { loaderAttributes: { size: 22, thickness: 5 } }))
            : (React.createElement(Input, { value: quantity.toString(), sx: {
                    borderLeft: (theme) => `1px solid ${theme.palette.secondary.dark}`,
                    borderRight: (theme) => `1px solid ${theme.palette.secondary.dark}`,
                    '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        display: 'none',
                    },
                    '& .MuiInput-input': {
                        minWidth: 37,
                        height: 16,
                        textAlign: 'center',
                        MozAppearance: 'textfield',
                    },
                }, onBlur: updateQuantity, onChange: changeQuantityValue, onKeyDown: keyPress, disabled: changeLoading || plant.shopify_quantity === 0, type: "number", disableUnderline: true, inputProps: {
                    min: 1,
                    pattern: '[0-9]*',
                    'aria-label': 'quantity',
                } })),
        React.createElement(IconButton, { sx: inputButtonRootSX, "aria-label": "add", size: "small", onClick: () => changeQuantityOnClick('add'), disabled: changeLoading || plant.shopify_quantity === 0 },
            React.createElement(AddIcon, null))));
}
